import React, { FC, memo } from 'react';
import styles from './product-error-page.module.css';
import { ProductErrorResponse } from '~/shared/utils/product/data-models';
import { Container } from '../../container/container.component';
import { Typography } from '~/shared/components';

const ProductErrorPage: FC<ProductErrorResponse> = memo(({ errorMessages }) => {
    if(!errorMessages || errorMessages.length === 0) {
        return null;
    }
    return (
        <Container spacingTop="none" spacingBottom="large" hasGutter="small" className={styles.root}>
            {errorMessages.map((msg, index) => (
                <Typography as="div" textAlign="center" variant="display5" key={`${index}-${msg}`}>
                    {msg}
                </Typography>
            ))}
        </Container>
    );
});

ProductErrorPage.displayName = 'ProductErrorPage';
export default ProductErrorPage;
